(function(Scroll, $, undefined) {

  Scroll.pauseWaypointFunctions = false;
  Scroll.scrollDirection;
  Scroll.smoothScroll = function($target, offset, speed) {
    if (!speed) {
      speed = 600
    } else {
      speed = parseInt(speed)
    }
    $('html, body').animate({
      scrollTop: $($target).offset().top - offset
    }, speed).promise().done(function() {
      Scroll.pauseWaypointFunctions = false;
    });
  }

  let lastScrollPosition = window.scrollY;

  const bindUIActions = function() {
    $(document).on('click', '[data-scroll]', function(e) {
      const $scrollTarget = $(this).attr('data-scroll');
      var offset = $(this).attr('data-scroll-offset');
      var offsetMobile = $(this).attr('data-scroll-offset-mobile');
      var speed = $(this).attr('data-scroll-speed');

      // if offset contains letter it must be an element 
      // and not a set pixel value. Checking for that here.
      if (/[a-z]/gi.test(offset)) {
        var offset = $(offset).outerHeight();
        var offsetMobile = $(offsetMobile).outerHeight()
      }

      if (offsetMobile && $(window).width() <= 1024) {
        offset = offsetMobile
      }

      e.preventDefault();
      Scroll.smoothScroll($scrollTarget, offset, speed);
    });

    window.onscroll = function() {
      let newScrollPosition = window.scrollY;
      let currentScrollDirection;

      if (newScrollPosition < lastScrollPosition) {
        currentScrollDirection = 'up'
      } else {
        currentScrollDirection = 'down'
      }

      if (currentScrollDirection !== Scroll.scrollDirection) {
        Scroll.scrollDirection = currentScrollDirection
        $(document).trigger('ss.scrollDirectionChanged', [{
          direction: Scroll.scrollDirection
        }]);
      }

      lastScrollPosition = newScrollPosition;
    }
  }

  const initStickyNav = function() {
    if ($(window).width() >= 1024) {
      new Waypoint({
        element: $('[data-sticky-nav-trigger]'),
        handler: function() {
          $('body').toggleClass('sticky-nav-active');
        },
        offset: Variables.headerHeight
      })
    }
  }

  Scroll.init = function() {
    bindUIActions();
    if ($('[data-sticky-nav-trigger]').length) {
      initStickyNav();
    }
  }

}(window.Scroll = window.Scroll || {}, jQuery));